// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"3c9c7797","647":"5c28027b"}[chunkId] + ".chunk.css";
};